import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import { Row, Container, Col, Form, Button, Modal, Spinner, Tab, Image, Nav, DropdownButton, Dropdown, Table } from "react-bootstrap"
import { FaList, FaThLarge } from 'react-icons/fa';
import $ from 'jquery'; 
import S from '../lib/Security';
import C from '../lib/Confg'
import N from '../lib/Network'
var Buffer = require('buffer/').Buffer
const AddIntegrationTemplate = ({ showTemplate, closeModal }) => {
    const [key,setKey]= useState("first");
    // const saveTabDetails = (event) => {
    //     var data = {
    //         callViaTms: 'Y',
    //         tenantEmployee: localStorage.getItem('username')
    //     };
    //     let inputData = S.getEncryptedJSON(data);
    //     const jsonString = JSON.stringify(inputData);
    //     const encodedString = Buffer.from(jsonString).toString('base64');
    //     var finalUrl = C.getP2PUrl() + 'master/companyMaster.tne?command=createCompanyMaster&encryptedURL=' + encodedString
    //     window.open(finalUrl, "_blank");
    // }
    const handleChange = (event) => {
        if (event.target.value === '0') {
            document.getElementById('if0').style.display = 'flex';
        }else{
            document.getElementById('if0').style.display = 'none';
        }
        if (event.target.value === '1') {
            document.getElementById('if1').style.display = 'flex';
        }else{
            document.getElementById('if1').style.display = 'none';
        }
        if (event.target.value === '2') {
            document.getElementById('if2').style.display = 'flex';
        }else{
            document.getElementById('if2').style.display = 'none';
        }
        if (event.target.value === '3') {
            document.getElementById('if3').style.display = 'flex';
        }else{
            document.getElementById('if3').style.display = 'none';
        }
        if (event.target.value === '4') {
            document.getElementById('if4').style.display = 'flex';
        }else{
            document.getElementById('if4').style.display = 'none';
        }
    }
    const handleChange1 = (event) => {
        if (event.target.value === '0') {
            document.getElementById('if6').style.display = 'flex';
            document.getElementById('if7').style.display = 'flex';
        }else{
            document.getElementById('if6').style.display = 'none';
            document.getElementById('if7').style.display = 'none';
        }
        if (event.target.value === '1') {
            document.getElementById('if6').style.display = 'flex';
            document.getElementById('if7').style.display = 'flex';
        }else{
            document.getElementById('if6').style.display = 'none';
            document.getElementById('if7').style.display = 'none';
        }
        if (event.target.value === '2') {
            document.getElementById('if7').style.display = 'flex';
        }else{
            document.getElementById('if7').style.display = 'none';
        }
        if (event.target.value === '3') {
            document.getElementById('if6').style.display = 'flex';
            document.getElementById('if5').style.display = 'flex';
        }else{
            document.getElementById('if6').style.display = 'none';
            document.getElementById('if5').style.display = 'none';
        }
        if (event.target.value === '4') {
            document.getElementById('if6').style.display = 'flex';
            document.getElementById('if5').style.display = 'flex';
        }else{
            document.getElementById('if6').style.display = 'none';
            document.getElementById('if5').style.display = 'none';
        }
    }
    const moduleNextTab = () =>{
        handleNextTabClick("fourth");
    }
    const nextTab = () =>{
        handleNextTabClick("second");
    }
    const handleNextTabClick = (key) => {
        setKey(key);
    };
    const handlePreviousTabClick = (key) => {
        setKey(key);
    };
    const moduleNextTabfifth = () =>{
        handleNextTabClick("sixth");
    };
    const closePopup = () => {
        closeModal();
    }
    return (
        <Modal id="" show={showTemplate}  animation={true}  size="xl">
            <Modal.Header closeButton onClick={() => closePopup()}>
                <Modal.Title><h5 className="headerTitle">Integration Template</h5></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                    {/* <!-- Begin Page Content --> */}
                    <Container fluid>
                        <Tab.Container id="left-tabs-example" onChange={handleNextTabClick} activeKey={key}>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <div className="multi-step">
                                        <Nav variant="pills" className="nav-justified">
                                            <Nav.Item>
                                                <Nav.Link className="item-wrap" eventKey="first"><p className="item-title disabled">Step 1</p></Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link className="item-wrap" eventKey="second"><p className="item-title disabled">Step 2</p></Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link className="item-wrap" eventKey="third"><p className="item-title disabled">Step 3</p></Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link className="item-wrap" eventKey="fourth"><p className="item-title disabled">Step 4</p></Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link className="item-wrap" eventKey="fifth"><p className="item-title disabled">Step 5</p></Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link className="item-wrap" eventKey="sixth"><p className="item-title disabled">Step 6</p></Nav.Link>
                                            </Nav.Item>
                                        </Nav>
                                    </div>
                                </Col>
                                <Col xs={12} md={12} lg={12} className="mt-4">
                                    <Tab.Content>
                                        <Tab.Pane eventKey="first">
                                            <Row>
                                                <Col xs={6} md={3} lg={3}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Template Name</Form.Label>
                                                        <Form.Control id="" name="companyName" type="text" className="form-control" placeholder="" />
                                                    </Form.Group>
                                                </Col>
                                                <Col xs={6} md={3} lg={3}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Template Description</Form.Label>
                                                        <Form.Control id="" name="companyName" type="text" className="form-control" placeholder="" />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Company Name</Form.Label>
                                                        <Form.Select name="Expenzing_SPOC_Name" id="" className="form-control">
                                                            <option value="0">- Select Company Name -</option>
                                                            <option value="1">Expenzing</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>ERP</Form.Label>
                                                        <Form.Select name="Expenzing_SPOC_Name" id="" className="form-control">
                                                            <option value="0">- Select ERP -</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Process</Form.Label>
                                                        <Form.Select name="Expenzing_SPOC_Name" id="" className="form-control">
                                                            <option value="0">- Select Process -</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Sub Process</Form.Label>
                                                        <Form.Select name="Expenzing_SPOC_Name" id="" className="form-control">
                                                            <option value="0">- Select Sub Process -</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col xs={12} md={12} lg={12} className="text-right mt-2">
                                                    <Button type="button" className="btn btn-sm btn-primary dt shadow-sm mr-2">Save & Close</Button>
                                                    <Button type="button" className="btn btn-sm btn-primary dt shadow-sm" onClick={()=>{handleNextTabClick("second"); }}>Save & Continue</Button>
                                                </Col>
                                            </Row>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="second">
                                            <Row>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Amounts in Fixed Decimals</Form.Label>
                                                        <Form.Control type='text' placeholder='' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Debit Credit Column Value Format</Form.Label>
                                                        <Form.Control as="select" id="integrationFormat" name='docList' onChange={handleChange}>
                                                            <option value="DEFAULT" >- Select Column -</option>
                                                            <option value="0" >Dr/Cr</option>
                                                            <option value="1" >D/C</option>
                                                            <option value="2" >Debit/Credit</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Amount Rounding</Form.Label>
                                                        <Form.Control as="select" id="integrationFormat" name='docList' onChange={handleChange}>
                                                            <option value="DEFAULT" >- Select Amount Rounding -</option>
                                                            <option value="0" >Half Up</option>
                                                            <option value="1" >Half Down</option>
                                                            <option value="2" >Half Even</option>
                                                            <option value="3" >Half Odd</option>
                                                            <option value="4" >Floor</option>
                                                            <option value="5" >Ceiling</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Accounting Date Format</Form.Label>
                                                        <Form.Control as="select" id="integrationFormat" name='docList' onChange={handleChange}>
                                                            <option value="DEFAULT" >- Select Format -</option>
                                                            <option value="0" >DDMMYY</option>
                                                            <option value="1" >DDMMYYYY</option>
                                                            <option value="2" >DD-MM-YY</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Accounting Period Format</Form.Label>
                                                        <Form.Control as="select" id="" name='docList' >
                                                            <option value="DEFAULT" >- Select Format -</option>
                                                            <option value="0" >MMYYYY</option>
                                                            <option value="1" >MMYY</option>
                                                            <option value="2" >0MMYYYY</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Supplier Credit Line GL Code</Form.Label>
                                                        <Form.Control as="select" id="" name='docList' >
                                                            <option value="DEFAULT" >- Select GL Code -</option>
                                                            <option value="0" >GL Code</option>
                                                            <option value="1" >Branch Sub Code</option>
                                                            <option value="2" >Other</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Default Value for Fail Conditions</Form.Label>
                                                        <Form.Control as="select" id="" name='docList' >
                                                            <option value="DEFAULT" >- Select Default Value -</option>
                                                            <option value="0" >NA</option>
                                                            <option value="1" >_NA</option>
                                                            <option value="2" >Blank Space</option>
                                                            <option value="3" >Null</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Entry Type</Form.Label>
                                                        <Form.Control as="select" id="" name='docList' >
                                                            <option value="DEFAULT" >- Select Entry Type -</option>
                                                            <option value="0" >Debit Entries</option>
                                                            <option value="1" >Debit & Credit Entries</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Debit Credit Mismatch Adjust Required</Form.Label>
                                                        <Form.Control as="select" id="" name='docList' >
                                                            <option value="DEFAULT" >- Select -</option>
                                                            <option value="0" >Yes</option>
                                                            <option value="1" >No</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Location Wise GST Entries</Form.Label>
                                                        <Form.Control as="select" id="" name='docList' >
                                                            <option value="DEFAULT" >- Select Location Wise -</option>
                                                            <option value="0" >Yes</option>
                                                            <option value="1" >No</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Blank Row After Voucher</Form.Label>
                                                        <Form.Control as="select" id="" name='docList' >
                                                            <option value="DEFAULT" >- Select -</option>
                                                            <option value="0" >Yes</option>
                                                            <option value="1" >No</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                {/* <Col lg='3' >
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Tenant</Form.Label>
                                                        <Form.Control type='text' placeholder='' />
                                                    </Form.Group>
                                                </Col> */}
                                            </Row>
                                            <Row>
                                                <Col xs={12} md={12} lg={12} className="text-right mt-4">
                                                    <Button type="button" className="btn btn-sm btn-primary dt float-left shadow-sm" onClick={()=>{handlePreviousTabClick("second"); }}>Previous</Button>
                                                    <Button type="button" className="btn btn-sm btn-primary dt shadow-sm mr-2">Save & Close</Button>
                                                    <Button type="button" className="btn btn-sm btn-primary dt shadow-sm" onClick={()=>{handleNextTabClick("third"); }}>Save & Continue</Button>
                                                </Col>
                                            </Row>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="third">
                                            <Row>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Integration Format</Form.Label>
                                                        <Form.Control as="select" id="integrationFormat" name='docList' onChange={handleChange}>
                                                            <option value="DEFAULT" >- Select Integration Format -</option>
                                                            <option value="0" >DB Integration</option>
                                                            <option value="1" >API</option>
                                                            <option value="2" >SFTP</option>
                                                            <option value="3" >FTP</option>
                                                            <option value="4" >Shared Drive</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Periodicity</Form.Label>
                                                        <Form.Control as="select" id="" name='docList' >
                                                            <option value="DEFAULT" >- Select Periodicity -</option>
                                                            <option value="0" >Daily</option>
                                                            <option value="1" >Weekly</option>
                                                            <option value="2" >Monthly</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>File Generation Time</Form.Label>
                                                        <Form.Control type='text' placeholder='HH/MM/SS' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>File Format</Form.Label>
                                                        <Form.Control as="select" id="fileFormat" name='docList'>
                                                            <option value="DEFAULT" >- Select File Format -</option>
                                                            <option value="0">CSV</option>
                                                            <option value="1">Text</option>
                                                            <option value="2">Excel</option>
                                                            <option value="3">XML</option>
                                                            <option value="4">JSON</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3' id="if5" style={{ display: "none" }}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>File Type</Form.Label>
                                                        <Form.Control as="select" id="" name='docList' >
                                                            <option value="DEFAULT" >- Select File Type -</option>
                                                            <option value="0">Rest/SOAP</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3' id="if6" style={{ display: "none" }}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Seperator To Be Used</Form.Label>
                                                        <Form.Control type='text' placeholder='HH/MM/SS' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3' id="if7" style={{ display: "none" }}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>File Name</Form.Label>
                                                        <Form.Control type='text' placeholder='' />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row id="if0" style={{ display: "none" }}>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>IP Address</Form.Label>
                                                        <Form.Control type='text' placeholder='IP address' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>SID</Form.Label>
                                                        <Form.Control type='text' placeholder='SID' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Port</Form.Label>
                                                        <Form.Control type='text' placeholder='Port' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>DB</Form.Label>
                                                        <Form.Control type='text' placeholder='DB' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Username</Form.Label>
                                                        <Form.Control type='text' placeholder='Username' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Password</Form.Label>
                                                        <Form.Control type='text' placeholder='Password' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>URL</Form.Label>
                                                        <Form.Control type='text' placeholder='URL' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>File Path</Form.Label>
                                                        <Form.Control type='text' placeholder='File Path' />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row id="if1" style={{ display: "none" }}>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>IP Address</Form.Label>
                                                        <Form.Control type='text' placeholder='IP address' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Username</Form.Label>
                                                        <Form.Control type='text' placeholder='Username' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Password</Form.Label>
                                                        <Form.Control type='text' placeholder='Password' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>URL</Form.Label>
                                                        <Form.Control type='text' placeholder='URL' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>File Path</Form.Label>
                                                        <Form.Control type='text' placeholder='File Path' />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row id="if2" style={{ display: "none" }}>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>IP Address</Form.Label>
                                                        <Form.Control type='text' placeholder='IP address' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Port</Form.Label>
                                                        <Form.Control type='text' placeholder='Port' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Username</Form.Label>
                                                        <Form.Control type='text' placeholder='Username' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Password</Form.Label>
                                                        <Form.Control type='text' placeholder='Password' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>File Path</Form.Label>
                                                        <Form.Control type='text' placeholder='File Path' />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row id="if3" style={{ display: "none" }}>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Username</Form.Label>
                                                        <Form.Control type='text' placeholder='Username' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Password</Form.Label>
                                                        <Form.Control type='text' placeholder='Password' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>URL</Form.Label>
                                                        <Form.Control type='text' placeholder='File Path' />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row id="if4" style={{ display: "none" }}>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Username</Form.Label>
                                                        <Form.Control type='text' placeholder='Username' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Password</Form.Label>
                                                        <Form.Control type='text' placeholder='Password' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>URL</Form.Label>
                                                        <Form.Control type='text' placeholder='File Path' />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={12} md={12} lg={12} className="text-right mt-4">
                                                    <Button type="button" className="btn btn-sm btn-primary dt float-left shadow-sm" onClick={()=>{handlePreviousTabClick("third"); }}>Previous</Button>
                                                    <Button type="button" className="btn btn-sm btn-primary dt shadow-sm mr-2">Save & Close</Button>
                                                    <Button type="button" className="btn btn-sm btn-primary dt shadow-sm" onClick={()=>{handleNextTabClick("fourth"); }}>Save & Continue</Button>
                                                </Col>
                                            </Row>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="fourth">
                                            <Row>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Auto Retrigger Count</Form.Label>
                                                        <Form.Control type='text' placeholder='' />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='3'>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Auto Retrigger After</Form.Label>
                                                        <Form.Control as="select" id="fileFormat" name='docList'>
                                                            <option value="DEFAULT" >- Select  -</option>
                                                            <option value="0"> 30 sec </option>
                                                            <option value="1"> 1 min </option>
                                                            <option value="2"> 2 min </option>
                                                            <option value="3"> 3 min </option>
                                                            <option value="4"> 5 min </option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={12} md={12} lg={12} className="text-right mt-4">
                                                    <Button type="button" className="btn btn-sm btn-primary dt float-left shadow-sm" onClick={()=>{handlePreviousTabClick("third"); }}>Previous</Button>
                                                    <Button type="button" className="btn btn-sm btn-primary dt shadow-sm mr-2">Save & Close</Button>
                                                    <Button type="button" className="btn btn-sm btn-primary dt shadow-sm" onClick={()=>{handleNextTabClick("fifth"); }}>Save & Continue</Button>
                                                </Col>
                                            </Row>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="fifth">
                                            <Row>
                                                <Table>
                                                    <thead>
                                                        <th>Entry Check</th>
                                                        <th>Field Code</th>
                                                        <th>Field Display Name</th>
                                                        <th>Column Sequence</th>
                                                        <th>Default Applicable</th>
                                                        <th>Default Value</th>
                                                        <th>Prefix</th>
                                                        <th>Suffix</th>
                                                        <th>Trim To Value</th>
                                                        <th>Field Information</th>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <Form.Control as="select" id="" name='docList' >
                                                                    <option value="DEFAULT" >- Select -</option>
                                                                    <option value="0" >Yes</option>
                                                                    <option value="1" >No</option>
                                                                </Form.Control>
                                                            </td>
                                                            <td>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Control type='text' placeholder='' />
                                                                </Form.Group>
                                                            </td>
                                                            <td>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Control type='text' placeholder='' />
                                                                </Form.Group>
                                                            </td>
                                                            <td>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Control type='text' placeholder='' />
                                                                </Form.Group>
                                                            </td>
                                                            <td>
                                                                <Form.Control as="select" id="" name='docList' >
                                                                    <option value="DEFAULT" >- Select -</option>
                                                                    <option value="0" >Yes</option>
                                                                    <option value="1" >No</option>
                                                                </Form.Control>
                                                            </td>
                                                            <td>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Control type='text' placeholder='' />
                                                                </Form.Group>
                                                            </td>
                                                            <td>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Control type='text' placeholder='' />
                                                                </Form.Group>
                                                            </td>
                                                            <td>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Control type='text' placeholder='' />
                                                                </Form.Group>
                                                            </td>
                                                            <td>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Control type='text' placeholder='' />
                                                                </Form.Group>
                                                            </td>
                                                            <td>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Control type='text' placeholder='' />
                                                                </Form.Group>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                                <Col xs={12} md={12} lg={12} className="text-right mt-4">
                                                    <Button type="button" className="btn btn-sm btn-primary dt float-left shadow-sm" >Previous</Button>
                                                    <Button type="button" className="btn btn-sm btn-primary dt shadow-sm" >Next</Button>
                                                </Col>
                                            </Row>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="sixth">
                                            <Row>
                                                <Table>
                                                    <thead>
                                                        <th>Entry Check</th>
                                                        <th>Field Code</th>
                                                        <th>Field Display Name</th>
                                                        <th>Column Sequence</th>
                                                        <th>Default Applicable</th>
                                                        <th>Default Value</th>
                                                        <th>Prefix</th>
                                                        <th>Suffix</th>
                                                        <th>Trim To Value</th>
                                                        <th>Field Information</th>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <Form.Control as="select" id="" name='docList' >
                                                                    <option value="DEFAULT" >- Select -</option>
                                                                    <option value="0" >Yes</option>
                                                                    <option value="1" >No</option>
                                                                </Form.Control>
                                                            </td>
                                                            <td>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Control type='text' placeholder='' />
                                                                </Form.Group>
                                                            </td>
                                                            <td>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Control type='text' placeholder='' />
                                                                </Form.Group>
                                                            </td>
                                                            <td>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Control type='text' placeholder='' />
                                                                </Form.Group>
                                                            </td>
                                                            <td>
                                                                <Form.Control as="select" id="" name='docList' >
                                                                    <option value="DEFAULT" >- Select -</option>
                                                                    <option value="0" >Yes</option>
                                                                    <option value="1" >No</option>
                                                                </Form.Control>
                                                            </td>
                                                            <td>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Control type='text' placeholder='' />
                                                                </Form.Group>
                                                            </td>
                                                            <td>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Control type='text' placeholder='' />
                                                                </Form.Group>
                                                            </td>
                                                            <td>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Control type='text' placeholder='' />
                                                                </Form.Group>
                                                            </td>
                                                            <td>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Control type='text' placeholder='' />
                                                                </Form.Group>
                                                            </td>
                                                            <td>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Control type='text' placeholder='' />
                                                                </Form.Group>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                                <Col xs={12} md={12} lg={12} className="text-right mt-4">
                                                    <Button type="button" className="btn btn-sm btn-primary dt float-left shadow-sm" >Previous</Button>
                                                    <Button type="button" className="btn btn-sm btn-primary dt shadow-sm" >Next</Button>
                                                </Col>
                                            </Row>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </Container>
            </Modal.Body>
        </Modal>
    )
}
export default AddIntegrationTemplate;	